import { mapGetters } from 'vuex';

export default {
    name: 'schoolsBreadcrumb',
    props:{
        breadCrumb: {
            type: Array,
            default() {
                return [];
            }
          },
        isBanner: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        ...mapGetters('glb', ['glb'])
    }
};